import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Control } from 'commons/js/ui/Dropdown'
import {
    required,
} from 'commons/js/util/validators'

import messages from './messages'

const getOptions = (labels) => labels.map((label) => {
    return {
        label,
        value: label,
    }
})

class FleetNumberField extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.object,
    }

    render () {
        const { intl } = this.props
        return (
            <Control
              dataTest='contact-form-fleet-number'
              id='.fleetNumber'
              model='.fleetNumber'
              validators={{
                    required: required(),
                }}
              showLabel
              validateIcon
              placeholder={intl.formatMessage(messages.fleetNumberPlaceholder)}
              nativePlaceholder={intl.formatMessage(messages.fleetNumberPlaceholderNative)}
              errorMessages={{
                    required: intl.formatMessage(messages.requiredError),
                }}
              label={intl.formatMessage(messages.fleetNumberLabel)}
              options={getOptions([
                    intl.formatMessage(messages.fleetNumberOptionMinus50),
                    intl.formatMessage(messages.fleetNumberOption50to259),
                    intl.formatMessage(messages.fleetNumberOption260to500),
                    intl.formatMessage(messages.fleetNumberOptionUp500),
                ])}
            />
        )
    }
}

export default injectIntl(FleetNumberField)
